import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1644895985299-245dddecef9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxtYW4lMjB1c2luZyUyMHNtYXJ0cGhvbmUlMjBvcmFuZ2UlMjBsaWdodGluZ3xlbnwwfHx8fDE3ODc5MjExMjZ8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const { t } = useLang();
  return (
    <section id="about" className="py-24 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="absolute -top-4 -left-4 w-full h-full border border-[#FF7900]/40" />
          <img
            src={ABOUT_IMG}
            alt="Conseiller Smart TA"
            className="relative w-full h-[420px] md:h-[560px] object-cover"
          />
          <div className="absolute bottom-6 right-6 bg-black/70 backdrop-blur-xl border border-white/10 px-6 py-4">
            <p className="font-display text-3xl font-medium text-[#FF7900]">10</p>
            <p className="text-xs uppercase tracking-widest text-white/60">ans · years</p>
          </div>
          <img
            src="/orange-distributor.png"
            alt="Distributeur Officiel Orange"
            className="absolute bottom-6 left-6 w-16 md:w-20 rounded-sm border border-white/10"
            data-testid="about-distributor-badge"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-[#FF7900] mb-6">{t.about.overline}</p>
          <h2 className="font-display text-4xl md:text-5xl font-medium tracking-tight mb-8">{t.about.title}</h2>
          <p className="text-base md:text-lg text-white/70 leading-relaxed mb-10">{t.about.text}</p>
          <ul className="flex flex-col gap-4">
            {t.about.points.map((p) => (
              <li key={p} className="flex items-center gap-4 text-white/80">
                <BadgeCheck className="w-5 h-5 text-[#FF7900] shrink-0" />
                {p}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
